import { initializeApp } from "firebase/app";
import { getMessaging, getToken, isSupported } from "firebase/messaging";
import { post } from "../redux/services/Api";
import firebaseConfig from "./firebase.config.json";

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize messaging as null
export let messaging = null;

// Initialize messaging if supported
export const initMessaging = async () => {
  try {
    if (await isSupported()) {
      messaging = getMessaging(app);
      return true;
    }
  } catch (error) {
    console.log("Firebase messaging not supported:", error);
  }
  return false;
};

// Request notification permission
export const requestPermission = async () => {
  console.log("Requesting permission...");
  try {
    // Check if notification is already granted
    if ("Notification" in window && Notification.permission === "granted") {
      await generateToken();
      return true;
    }

    // Request permission if not granted
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      console.log("Notification permission granted.");
      await generateToken();
      return true;
    }
  } catch (error) {
    console.log("Error requesting permission:", error);
  }
  return false;
};

// Generate and register FCM token
const generateToken = async () => {
  try {
    // Initialize messaging if not done already
    if (!messaging) {
      await initMessaging();
    }

    if (!messaging) {
      console.log("Messaging not initialized");
      return null;
    }

    const currentToken = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
    });

    if (currentToken) {
      // Get or create device ID
      let deviceId = localStorage.getItem("deviceId");
      if (!deviceId) {
        deviceId = "web" + Math.random().toString(20).substring(2, 14);
        localStorage.setItem("deviceId", deviceId);
      }

      // Register token with backend
      const token = localStorage.getItem("token");
      if (token) {
        await post(
          "/device-tokens",
          {
            deviceId,
            token: currentToken,
          },
          {
            Authorization: `Bearer ${token}`,
          }
        );
      }

      return currentToken;
    } else {
      console.log("No registration token available");
    }
  } catch (err) {
    console.log("Error generating token:", err);
  }
  return null;
};

// Initialize notifications on app start
export const initializeNotifications = async () => {
  await initMessaging();

  // Auto-request permission if already granted
  if ("Notification" in window && Notification.permission === "granted") {
    await requestPermission();
  }
};
